/**
 * KAN-684: открыта ли самостоятельная регистрация.
 *
 * Флаг меняется только сменой env на сервере с рестартом, поэтому кэш 5 минут.
 * `allowed` = true только при явном ответе сервера; пока ответа нет или при
 * ошибке регистрация считается закрытой (закрытая система по умолчанию).
 */
import { useQuery } from '@tanstack/react-query';
import {
  REGISTRATION_STATUS_QUERY_KEY,
  registrationApi,
  type RegistrationStatus,
} from '@/services/api/registration';

const FIVE_MINUTES = 5 * 60 * 1000;

export function useRegistrationStatus() {
  const query = useQuery<RegistrationStatus>({
    queryKey: REGISTRATION_STATUS_QUERY_KEY,
    queryFn: registrationApi.getStatus,
    staleTime: FIVE_MINUTES,
    retry: 1,
  });
  return {
    allowed: query.data?.allowed === true,
    isLoading: query.isLoading,
  };
}
